/**
 * class to handle HTTP Requests and Token refresh
 */

import querystring from 'querystring';
import { initOptionHeader, ACCESS_TOKEN, REFRESH_TOKEN } from '../../utils/common';
import jwtDecode from 'jwt-decode';
export const httpBackOfficeUtil = {
    setupChannel,
    put,
    post,
    get,
    sendDelete,
    uploadFile,
    is200OK,
    startSessionForVerify,
    getSessionForVerify,
    clearSessionForVerify,
    startSession,
    getSession,
    cleanObj,
    cleanSession,
    refreshToken,
    getURI,
    uploadFileNew,
    getToken,
    saveSelfSchedulingUser
};


/** local variables */

let _storeKVFn;
let _getKVFn;
let _sessionInvalidCallback;
let _fetchFn;

let _apiKey;
let _accessToken;
let _refreshToken;
let _host;
let _sessionData;

let _selfServicePath = '/self-service'
let _backofficePath = '/backoffice'
let _ssl_pinning_options;
let _enable_ssl_pinning;
let _isBackend;
let _middleware_host;
let _middleware_apiKey;

let _accessTokenTemp;
let _accessTokenExpTemp;
/**
 * 
 * TODO: do we need a call back for no internet connection ?
 * when no connection refresh token will not be available -> should not kick user out.
 */

async function setupChannel({
    storeKVFn,  //function to store key value
    getKVFn,    //function to get value by key from the storage
    sessionInvalidCallback, //function to call when api_key or token key is invalid and refresh token if available was failed
    apiKey,
    host,
    fetchFn,
    sslPinningOptions,
    enableSslPinning,
    isBackend,
    middlewareHost,
    middlewareApiKey
}) {
    _storeKVFn = storeKVFn;
    _getKVFn = getKVFn;
    _sessionInvalidCallback = sessionInvalidCallback;
    _apiKey = apiKey;
    _host = host;
    _enable_ssl_pinning = enableSslPinning;
    _ssl_pinning_options = sslPinningOptions;
    _middleware_host = middlewareHost
    _middleware_apiKey = middlewareApiKey
    if (fetchFn)
        _fetchFn = fetchFn;
    else
        _fetchFn = fetch;
    if (isBackend) {
        _isBackend = isBackend;
    }
    if (_getKVFn) {
        _accessToken = await _getKVFn(ACCESS_TOKEN ? ACCESS_TOKEN : 'access_token');
        _refreshToken = await _getKVFn(REFRESH_TOKEN ? REFRESH_TOKEN : 'refresh_token');
        try {
            if (_accessToken) {
                _sessionData = jwtDecode(_accessToken);
                await checkRefreshToken();
            }
            else if (_refreshToken) {
                await refreshToken(true);
            }
        } catch (e) {
            console.log('Failed to load session data: ', e);
            _sessionData = undefined;
        }
    }
    //TODO add silent refresh token here
}

async function checkRefreshToken() {
    let currentTime = Date.now();
    let tokenLiveInSec = (_sessionData.exp - currentTime / 1000);
    //console.log('tokenLiveInSec====', tokenLiveInSec)
    if (tokenLiveInSec > 60 * 60)
        return;
    else
        await refreshToken(true);
}

async function refreshToken(logOutIfSessionInvalid) {
    try {
        console.log('_refreshToken:', _refreshToken);
        console.log('AAAAAAAAAAAAAAAAAA start to refresh:');
        console.log('AAAAAAAAAAAAAAAAAA start to refresh:');
        console.log('AAAAAAAAAAAAAAAAAA start to refresh:');
        console.log('AAAAAAAAAAAAAAAAAA start to refresh:');
        let path = '/v1/contacts/refresh';
        if (_isBackend) {
            path = '/v1/users/refresh'
        }
        let response = await postRefreshToken({
            resourcePath: path,
            body: {},
            isBackend: _isBackend
        });
        console.log('AAAAAAAAAAAAAAAAAA response:', response);
        if (response.status == "200") {
            let bodyText = await response.text()
            console.log('refreshToken bodyText:', bodyText);
            startSession(json2Obj(bodyText));
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            validateForceLogout(response, true);
            return response;
        }
    } catch (e) {
        validateForceLogout(e, true);
        return e;
    }
}

function startSessionForVerify({ access_token, expiration_date }) {
    //TODO handle expiration
    _accessTokenTemp = access_token;
    _accessTokenExpTemp = expiration_date;
    if (_storeKVFn) {
        _storeKVFn("access_token_temp", access_token);
        _storeKVFn("access_token_exp_temp", expiration_date);
    }
}

function clearSessionForVerify() {
    //TODO handle expiration
    _accessTokenTemp = undefined;
    _accessTokenExpTemp = undefined;
    if (_storeKVFn) {
        _storeKVFn("access_token_temp", undefined);
        _storeKVFn("access_token_exp_temp", undefined);
    }
}

function getSessionForVerify() {
    if (!_accessTokenTemp) {
        _accessTokenTemp =  _getKVFn("access_token_temp");
    }
    if (!_accessTokenExpTemp) {
        _accessTokenExpTemp =  _getKVFn("access_token_exp_temp");
    }
    //TODO handle expiration
    let currentTime = Date.now() / 1000;
    if(currentTime >= _accessTokenExpTemp){
        clearSessionForVerify();
    }
    return _accessTokenTemp;
}

function startSession({ access_token, refresh_token, exp, communities, isSelfScheduleingUser }) {
    // console.log('start session isscheduling user   ', isSelfScheduleingUser);
    //TODO handle expiration
    _accessToken = access_token;
    _refreshToken = refresh_token;
    if (_storeKVFn) {
        _storeKVFn(REFRESH_TOKEN ? REFRESH_TOKEN : "refresh_token", refresh_token)
        _storeKVFn(ACCESS_TOKEN ? ACCESS_TOKEN : "access_token", access_token)
        _storeKVFn("communities", JSON.stringify(communities))
        // _storeKVFn("exp", exp)
        //parse and store session data
        _sessionData = jwtDecode(_accessToken);
        // console.log('Session data:', _sessionData);
    }

}

function saveSelfSchedulingUser(isSelfScheduleingUser) {
    if (_storeKVFn) {
        _storeKVFn("isSelfScheduleingUser", isSelfScheduleingUser);
    }
}

function cleanSession() {
    //TODO handle expiration
    _accessToken = undefined;
    _refreshToken = undefined;
    if (_storeKVFn) {
        _storeKVFn(REFRESH_TOKEN ? REFRESH_TOKEN : "refresh_token", undefined)
        _storeKVFn(ACCESS_TOKEN ? ACCESS_TOKEN : "access_token", undefined)
        _storeKVFn("isSelfScheduleingUser", undefined);
        //parse and store session data
        console.log('Session cleared');
    }
    _sessionData = undefined;
    console.log("AAA _sessionData:", _sessionData);
}

function getSession() {
    return _sessionData;
}

function getToken() {
    return _accessToken;
}

function getURI(isBackend, resourcePath, isMiddleware) {
    if (isMiddleware) {
        return _middleware_host + resourcePath;
    } else {
        if (isBackend == true)
            return _host + _backofficePath + resourcePath;
        else
            return _host + _selfServicePath + resourcePath;
    }
}

export function json2Obj(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}
async function post({
    resourcePath,
    body,
    queryParams,
    withAccessToken = false,
    withoutApikey = false,
    isBackend = true,
    logOutIfSessionInvalid = true,
    isRefreshToken,
    accessToken,
    returnText,
    isMiddleware = false
}) {
    try {
        let uri = getURI(isBackend, resourcePath, isMiddleware);
        var options = {};
        options.headers = initOptionHeader();
        options.method = "POST";
        options.credentials = 'omit';
        if (isMiddleware) {
            options.headers['x-api-key'] = _middleware_apiKey;
        } else {
            if (withAccessToken == true || logOutIfSessionInvalid == true || isRefreshToken == true || accessToken) {
                console.log("AAAAAAAAAAAAAAAAAAAA b111111111111111111111:");
                if (isRefreshToken)
                    options.headers['Authorization'] = 'Bearer ' + _refreshToken;
                else if (accessToken) {
                    options.headers['Authorization'] = 'Bearer ' + accessToken;
                }
                else
                    options.headers['Authorization'] = 'Bearer ' + _accessToken;
            }
            else if (!withoutApikey) {
                options.headers['api_key'] = _apiKey;
            }
        }
        console.log("options:", options);
        if (body)
            options.body = JSON.stringify(body);
        //console.log("_ssl_certificates:", _ssl_certificates);
        if (_enable_ssl_pinning && _ssl_pinning_options)
            options = { ...options, ..._ssl_pinning_options };
        if (queryParams)
            uri = uri + '?' + querystring.encode(queryParams);
        console.log('POST: ', uri, options);
        let response = await _fetchFn(uri, options);
        if (response.status == '200' || response.status == '201' || response.status == '204') {
            if (returnText) {
                let bodyText = await response.text()
                console.log('Response - ', response.status, ' - Body text:', bodyText);
                return { code: "OK", data: bodyText };
            } else {
                let bodyText = await response.text()
                console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
                return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
            }
        } else if (response.status == '401') {
            var refreshResult = await refreshToken(logOutIfSessionInvalid);
            console.log('AAAAAAAAAAAAAAAAAA POST refreshResult:', refreshResult);
            if (refreshResult.code == 'OK') {
                options.headers = { ...options.headers, Authorization: "Bearer " + refreshResult.data.access_token };
                options = { ...options, headers: options.headers };
                response = await _fetchFn(uri, options);
                let bodyText = await response.text()
                if (response.status == '200') {
                    return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
                }
                return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
            } else {
                validateForceLogout(refreshResult, true);
            }
        } else {
            let bodyText = await response.text()
            validateForceLogout(response, logOutIfSessionInvalid);
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        let bodyText = await e.text();
        // if (e.status == '401') {
        //     let uri = getURI(isBackend, resourcePath);
        //     if (queryParams)
        //         uri = uri + '?' + querystring.encode(queryParams);
        //     var result = await processRefreshToken(uri,logOutIfSessionInvalid);
        //     return result;
        // }
        return { code: e.status, bodyText: bodyText, error: returnText ? bodyText : json2Obj(bodyText) };
    }
}

async function postRefreshToken({
    resourcePath,
    body,
    isBackend=true
}) {
    try {
        let uri = getURI(isBackend, resourcePath);
        var options = {};
        options.headers = initOptionHeader();
        options.method = "POST";
        options.credentials = 'omit';
        options.headers['Authorization'] = 'Bearer ' + _refreshToken;
        if (body)
            options.body = JSON.stringify(body);
        if (_enable_ssl_pinning && _ssl_pinning_options)
            options = { ...options, ..._ssl_pinning_options };
        console.log('POST: ', uri, options);
        let response = await _fetchFn(uri, options);
        console.log('RESPONSE postRefreshToken: ', response);
        return response;
    } catch (e) {
        return e;
    }
}

async function validateForceLogout(response, logOutIfSessionInvalid) {
    console.log("response:", response);
    console.log("logOutIfSessionInvalid:", logOutIfSessionInvalid);
    try {
        if (logOutIfSessionInvalid == true && _sessionInvalidCallback && response.status == '401') {
            await _sessionInvalidCallback(true);
            cleanSession();
        } else {
            return response;
        }
    } catch (e) {
        console.log(e);
        return e;
    }
}

async function get({
    resourcePath,
    queryParams,
    withAccessToken = false,
    isBackend = true,
    logOutIfSessionInvalid = true,
    returnText = false,
    unauthorize = false,
    returnBlob = false,
    apiKey,
    isMiddleware = false
}) {
    console.log("withAccessToken:", withAccessToken);
    console.log("unauthorize:", unauthorize);
    console.log("apiKey:", apiKey);
    try {
        let uri = getURI(isBackend, resourcePath, isMiddleware);
        var options = {};
        options.headers = initOptionHeader();
        options.method = "GET";
        options.credentials = 'omit';
        if (isMiddleware) {
            options.headers['x-api-key'] = _middleware_apiKey;
        } else {
            if (withAccessToken == true || logOutIfSessionInvalid == true)
                options.headers['Authorization'] = 'Bearer ' + _accessToken;
            else if (!unauthorize)
                options.headers['api_key'] = apiKey ? apiKey : _apiKey;
        }
        if (_enable_ssl_pinning && _ssl_pinning_options)
            options = { ...options, ..._ssl_pinning_options };
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));
        console.log('GET: ', uri, options);
        let response = await _fetchFn(uri, options);
        console.log("response:", response);
        if (response.status == '200') {
            if (returnText) {
                let bodyText = await response.text()
                console.log('Response - ', response.status, ' - Body text:', bodyText);
                return { code: "OK", data: bodyText };
            } else if (returnBlob) {
                let blob = await response.blob();
                console.log('Response - ', response.status, ' - Body blob:', blob);
                return { code: "OK", data: blob ? blob : null };
            } else {
                let bodyText = await response.text()
                console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
                return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
            }
        } else if (response.status == '401') {
            var result = await processRefreshToken(uri, logOutIfSessionInvalid, returnText);
            return result;
        } else {
            let bodyText = await response.text()
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("AAA e:", e);
        let bodyText = await e.text();
        // if (e.status == '401') {
        //     let uri = getURI(isBackend, resourcePath);
        //     if (queryParams)
        //         uri = uri + '?' + querystring.encode(cleanObj(queryParams));
        //     var result = await processRefreshToken(uri,logOutIfSessionInvalid,returnText);
        //     return result;
        // }
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function sendDelete({
    resourcePath,
    queryParams,
    withAccessToken = false,
    isBackend = true,
    logOutIfSessionInvalid = true,
    isMiddleware = false
}) {
    try {
        let uri = getURI(isBackend, resourcePath, isMiddleware);
        var options = {};
        options.headers = initOptionHeader();
        options.method = "DELETE";
        options.credentials = 'omit';
        if (isMiddleware) {
            options.headers['x-api-key'] = _middleware_apiKey;
        } else {
            if (withAccessToken == true || logOutIfSessionInvalid == true)
                options.headers['Authorization'] = 'Bearer ' + _accessToken;
            else
                options.headers['api_key'] = _apiKey;
        }
        if (_enable_ssl_pinning && _ssl_pinning_options)
            options = { ...options, ..._ssl_pinning_options };
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));
        //console.log('GET: ', uri, options);
        let response = await _fetchFn(uri, options);
        let bodyText = await response.text()
        //console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else if (response.status == '401') {
            var refreshResult = await refreshToken(logOutIfSessionInvalid);
            if (refreshResult.code == 'OK') {
                options.headers = { ...options.headers, Authorization: "Bearer " + refreshResult.data.access_token };
                options = { ...options, headers: options.headers };
                response = await _fetchFn(uri, options);
                bodyText = await response.text()
                if (response.status == '200') {
                    return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
                }
                return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
            } else {
                validateForceLogout(refreshResult, true);
            }
        } else {
            validateForceLogout(response, logOutIfSessionInvalid);
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        let bodyText = await e.text();
        // if (e.status == '401') {
        //     let uri = getURI(isBackend, resourcePath);
        //     if (queryParams)
        //         uri = uri + '?' + querystring.encode(cleanObj(queryParams));
        //     var result = await processRefreshToken(uri,logOutIfSessionInvalid);
        //     return result;
        // }
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function put({
    resourcePath,
    body,
    queryParams,
    withAccessToken = false,
    isBackend = true,
    logOutIfSessionInvalid = true,
    isMiddleware = false
}) {
    try {
        let uri = getURI(isBackend, resourcePath, isMiddleware);
        var options = {};
        options.headers = initOptionHeader();
        options.method = "PUT";
        options.credentials = 'omit';
        if (isMiddleware) {
            options.headers['x-api-key'] = _middleware_apiKey;
        } else {
            if (withAccessToken == true || logOutIfSessionInvalid == true)
                options.headers['Authorization'] = 'Bearer ' + _accessToken;
            else
                options.headers['api_key'] = _apiKey;
        }
        if (body)
            options.body = JSON.stringify(body);
        if (_enable_ssl_pinning && _ssl_pinning_options)
            options = { ...options, ..._ssl_pinning_options };
        if (queryParams)
            uri = uri + '?' + querystring.encode(queryParams);
        console.log('PUT: ', uri, options);
        let response = await _fetchFn(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else if (response.status == '401') {
            var refreshResult = await refreshToken(logOutIfSessionInvalid);
            if (refreshResult.code == 'OK') {
                options.headers = { ...options.headers, Authorization: "Bearer " + refreshResult.data.access_token };
                options = { ...options, headers: options.headers };
                response = await _fetchFn(uri, options);
                bodyText = await response.text()
                if (response.status == '200') {
                    return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
                }
                return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
            } else {
                validateForceLogout(refreshResult, true);
            }
        } else {
            validateForceLogout(response, logOutIfSessionInvalid);
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        let bodyText = await e.text();
        // if (e.status == '401') {
        //     let uri = getURI(isBackend, resourcePath);
        //     if (queryParams)
        //         uri = uri + '?' + querystring.encode(cleanObj(queryParams));
        //     var result = await processRefreshToken(uri,logOutIfSessionInvalid);
        //     return result;
        // }
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}


function is200OK(result) {
    if (result && result.status && result.status == '200')
        return true;
    else
        return false;
}

function cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
}

async function processRefreshToken(uri, logOutIfSessionInvalid, returnText) {
    try {
        var refreshResult = await refreshToken(logOutIfSessionInvalid);
        console.log('AAAAAAAAAAAAAAAAAA GET refreshResult:', refreshResult);
        if (refreshResult.code == 'OK') {
            var options = {};
            options.headers = initOptionHeader();
            options.method = "GET";
            options.credentials = 'omit';
            if (_enable_ssl_pinning && _ssl_pinning_options)
                options = { ...options, ..._ssl_pinning_options };
            options.headers = { ...options.headers, Authorization: "Bearer " + refreshResult.data.access_token };
            options = { ...options, headers: options.headers };
            var response = await _fetchFn(uri, options);
            var bodyText = await response.text()
            if (response.status == '200') {
                if (returnText)
                    return { code: "OK", data: bodyText };
                return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
            }
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        } else {
            validateForceLogout(refreshResult, true);
        }
    } catch (error) {
        console.log("process refreshtoken exception:", error);
        validateForceLogout(error, true);
    }
}

async function uploadFile({
    resourcePath,
    fileData,
    body,
    queryParams,
    withAccessToken = false,
    withoutApikey = false,
    isBackend = true,
    logOutIfSessionInvalid = true,
    accessToken,
    isMiddleware = false,
    method = 'POST',
    keyParam = 'file',
    disalbedContentType = false,
}) {
    try {
        let uri = getURI(isBackend, resourcePath, isMiddleware);
        var options = {};
        
        if(!disalbedContentType){
            options.headers = {
                'User-Agent': 'request',
                'Content-Type': 'multipart/form-data'
            };
        } 
        else {
            options.headers = {};
        }
        if (isMiddleware) {
            options.headers['x-api-key'] = _middleware_apiKey;
        } else {
            if (withAccessToken == true || logOutIfSessionInvalid == true) {
                if (accessToken) {
                    options.headers['Authorization'] = 'Bearer ' + accessToken;
                }
                else
                    options.headers['Authorization'] = 'Bearer ' + _accessToken;
            }
            else if (!withoutApikey) {
                options.headers['api_key'] = _apiKey;
            }
        }
        var formData = new FormData();
        if (fileData) {
            console.log("fileData==", fileData);
            formData.append(keyParam, fileData);
        }
        if (body) {
            formData.body = JSON.stringify(body);
        }
        options.method = method;
        options.credentials = 'omit';
        options.body = formData;
        //console.log("_ssl_certificates:", _ssl_certificates);
        if (_enable_ssl_pinning && _ssl_pinning_options)
            options = { ...options, ..._ssl_pinning_options };
        console.log('UPLOAT FILE POST: ', uri, options);
        let response = await _fetchFn(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
        if (response.status == '200' || response.status == '201' || response.status == 201) {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else if (response.status == '401') {
            var refreshResult = await refreshToken(logOutIfSessionInvalid);
            console.log('AAAAAAAAAAAAAAAAAA POST refreshResult:', refreshResult);
            if (refreshResult.code == 'OK') {
                options.headers = { ...options.headers, Authorization: "Bearer " + refreshResult.data.access_token };
                options = { ...options, headers: options.headers };
                response = await _fetchFn(uri, options);
                bodyText = await response.text()
                if (response.status == '200' || response.status == '201' || response.status == 201) {
                    return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
                }
                return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
            } else {
                validateForceLogout(refreshResult, true);
            }
        } else {
            validateForceLogout(response, logOutIfSessionInvalid);
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (error) {
        console.log("process uploadFile exception:", error);
        validateForceLogout(error, true);
    }

}

async function uploadFileNew({
    resourcePath,
    fileData,
    body,
    queryParams,
    withAccessToken = false,
    withoutApikey = false,
    isBackend = true,
    logOutIfSessionInvalid = true,
    accessToken,
    isMiddleware = false
}) {
    try {
        let uri = getURI(isBackend, resourcePath, isMiddleware);

        var formData = new FormData();
        if (fileData) {
            console.log("fileData==", fileData);
            formData.append('file', fileData);
        }

        var options = {
            method: 'POST',
            body: formData,
            credentials: 'omit',
            headers: {},
        };
        if (isMiddleware) {
            options.headers['x-api-key'] = _middleware_apiKey;
        } else {
            if (withAccessToken == true || logOutIfSessionInvalid == true) {
                if (accessToken) {
                    options.headers['Authorization'] = 'Bearer ' + accessToken;
                }
                else
                    options.headers['Authorization'] = 'Bearer ' + _accessToken;
            }
            else if (!withoutApikey) {
                options.headers['api_key'] = _apiKey;
            }
        }
        //console.log("_ssl_certificates:", _ssl_certificates);
        if (_enable_ssl_pinning && _ssl_pinning_options)
            options = { ...options, ..._ssl_pinning_options };
        console.log('UPLOAT FILE POST: ', uri, options);
        let response = await _fetchFn(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else if (response.status == '401') {
            var refreshResult = await refreshToken(logOutIfSessionInvalid);
            console.log('AAAAAAAAAAAAAAAAAA POST refreshResult:', refreshResult);
            if (refreshResult.code == 'OK') {
                options.headers = { ...options.headers, Authorization: "Bearer " + refreshResult.data.access_token };
                options = { ...options, headers: options.headers };
                response = await _fetchFn(uri, options);
                bodyText = await response.text()
                if (response.status == '200') {
                    return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
                }
                return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
            } else {
                validateForceLogout(refreshResult, true);
            }
        } else {
            validateForceLogout(response, logOutIfSessionInvalid);
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (error) {
        console.log("process uploadFile exception:", error);
        validateForceLogout(error, true);
    }

}
